import { FormControl, InputLabel, MenuItem, Select, ThemeProvider } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
//import { useState } from 'react';
import Swal from 'sweetalert2';

import useWindowSize from '../../hooks/useWindowSize';
import { FieldComponentFont } from '../../Styles/componentStyles';

function SelectPeriod({ selectedPeriod,setSelectedPeriod,listeVal,setCustomDateRange }) {
    SelectPeriod.propTypes = {
        userType: PropTypes.any,
        selectedPeriod: PropTypes.any,
        setSelectedPeriod: PropTypes.func,
        setCustomDateRange: PropTypes.func,
        listeVal:PropTypes.any,
    };
    const { i18n } = useTranslation();
    //const [customOpen, setCustomOpen] = useState(false); // Track if custom modal is open
    const handleCustomPeriodChange = () => {
        setSelectedPeriod('custom');
        Swal.fire({
            title: i18n.t('Personnaliser plage de dates'),
            html: `
            <input type="date" id="fromDate" class="swal2-input" placeholder="From">
            <input type="date" id="toDate" class="swal2-input" placeholder="To">
            `,
            focusConfirm: false,
            preConfirm: () => {
                const fromDate = document.getElementById('fromDate').value;
                const toDate = document.getElementById('toDate').value;

                if (fromDate > toDate) {
                    Swal.showValidationMessage(i18n.t('La date de fin doit être postérieure à la date de début.'));
                } else {
                    setCustomDateRange({ from: fromDate, to: toDate });
                }
            },
        });
    };

    //const handleCustomPeriodChange = (event) => {
    //    const selectedValue = event.target.value;
    //    setSelectedPeriod(selectedValue);

    //    if (selectedValue === 'custom') {
    //      setCustomOpen(true);
    //    } else {
    //      setCustomDateRange({ from: '', to: '' });
    //      setCustomOpen(false);
    //    }
    //  };

    //  const handleCustomModalConfirm = () => {
    //    const fromDate = document.getElementById('fromDate').value;
    //    const toDate = document.getElementById('toDate').value;
    //    setCustomDateRange({ from: fromDate, to: toDate });
    //    setCustomOpen(false);
    //  };
    //const openCustomModal = () => {
    //    Swal.fire({
    //      title: 'Personnaliser plage de dates',
    //      html: `
    //        <input type="date" id="fromDate" class="swal2-input" placeholder="From">
    //        <input type="date" id="toDate" class="swal2-input" placeholder="To">
    //      `,
    //      focusConfirm: false,
    //      preConfirm: handleCustomModalConfirm,
    //      onClose: () => setCustomOpen(false),
    //    });
    //  };
    const { inputSize } = useWindowSize();
    console.log('selectedPeriod selectedPeriod',selectedPeriod);
    return (
        <ThemeProvider theme={FieldComponentFont}>
            <FormControl
                fullWidth
            >
                <InputLabel
                    shrink={true}
                    id="demo-simple-select-label"
                >{i18n.t('Période')}</InputLabel>
                <Select
                    label={i18n.t('Période')}
                    name='Période'
                    notched={true}
                    size={inputSize}
                    sx={{
                        '& > :not(style)': { borderRadius: '8px' },
                    }}
                    value={selectedPeriod}
                    style={{ width: '100%', background: 'white' }}
                    onChange={(event)=>{
                        const selectedValue = event.target.value;
                        setSelectedPeriod(selectedValue);
                        setCustomDateRange({ from: '', to: '' });
                    }}

                >
                    {Array.isArray(listeVal) && listeVal?.map((element, i) => (
                        <MenuItem
                            value={element?.value ||
                                element?.country ||
                                element?.region ||
                                element?._id ||
                                element}
                            key={i}
                            style={element.hidden ? { display: 'none' } : {}}
                        > {i18n.t(element?.label) ||
                        i18n.t(element?.country) ||
                        i18n.t(element?.region) ||
                            i18n.t(element?.nom) ||
                                i18n.t(element)}</MenuItem>
                    ))}

                    <div>
                        <button
                            style={{
                                width: '100%',
                                //marginTop: '8px',
                                height:'36px',
                                textAlign: 'left',
                                paddingLeft: '16px',
                                border: 'none',
                                background: 'white',
                                fontFamily: 'Lato',
                                fontStyle: 'normal',
                                fontWeight: '400',
                                fontSize: '16px',
                                letterSpacing: '-0.0044em',
                                color:'black',
                                cursor: 'pointer',
                            }}
                            onClick={handleCustomPeriodChange}
                            onMouseEnter={(event) => {
                                event.target.style.backgroundColor = 'rgba(0, 0, 0, 0.04)'; // Set background color on hover
                            }}
                            onMouseLeave={(event) => {
                                event.target.style.backgroundColor = 'white'; // Reset background color on hover exit
                            }}
                        >{i18n.t('Custom')}</button>
                    </div>
                </Select>
                {/*<FormHelperText>{showErrors && (error ?? '')}</FormHelperText>*/}

            </FormControl>
        </ThemeProvider>
        //<SelectComponent
        //    label={'Période'}
        //    val={selectedPeriod}
        //    name='périodeList'
        //    setVal={handleCustomPeriodChange}
        //    listVal={listeVal}
        ///>
    );
}

export default SelectPeriod;
//    return (
//        <>
//            <SelectComponent
//                label={'Période'}
//                val={selectedPeriod}
//                name='périodeList'
//                setVal={handleCustomPeriodChange}
//                listVal={listeVal}
//            />
//            {customOpen && openCustomModal()}
//        </>
//    );
//}

//export default SelectPeriod;